module.exports = __webpack_public_path__ + "static/directory_1-e6dc30a593c2cd7bce0d68e244be50b7.png";